import React, { FC, useEffect } from "react";

import { useIntl } from "react-intl";

import useDynamicCallback from "@mapmycustomers/shared/util/hook/useDynamicCallback";
import useStateWithDebouncedListener from "@mapmycustomers/shared/util/hook/useStateWithDebouncedListener";
import { SearchField } from "@mapmycustomers/ui";

import styles from "./QuickSearch.module.scss";

export interface QuickSearchProps {
  onChange: (value: string) => void;
  value: string;
}

const QuickSearch: FC<QuickSearchProps> = ({ onChange, value }) => {
  const intl = useIntl();

  const [innerValue, setInnerValue, resetInnerValue] = useStateWithDebouncedListener(
    [onChange, 500],
    ""
  );

  const handleEnterPress = useDynamicCallback(() => {
    onChange(innerValue);
  });

  useEffect(() => {
    resetInnerValue(value);
  }, [resetInnerValue, value]);

  return (
    <SearchField
      className={styles.container}
      onChange={setInnerValue}
      onPressEnter={handleEnterPress}
      placeholder={intl.formatMessage({
        id: "onboarding.users.filters.quickSearch",
        defaultMessage: "Search users",
        description: "Quick Search field placeholder on the User Guides page",
      })}
      size="middle"
      value={innerValue}
    />
  );
};

export default QuickSearch;
